import {
  dateTimeStringToDate,
  differenceInMinutes,
  differenceInDays,
} from "../../../common/helpers/time";
class CreatePassFailReportCardController {
  constructor(
    $state,
    $stateParams,
    DrivesModel,
    FlashService,
    ReportcardsModel,
    student,
    $window,
  ) {
    this.$window = $window;
    this.$stateParams = $stateParams;
    this.reportcard = {
      student: {
        firstname: student.firstname,
        lastname: student.lastname,
      },
    };

    this.drive = [];
    this.tasks = [];
    this.grades = [];
    this.gradeIncomplete = true;

    this.$state = $state;
    this.ReportcardsModel = ReportcardsModel;
    this.FlashService = FlashService;

    DrivesModel.getDriveByID($stateParams.driveId).then((response) => {
      this.drive = response.drive;
      this.driveDate = dateTimeStringToDate(
        this.drive.drive_date + " " + this.drive.start_time,
      );
      this.untilDrive = this.getRelativeTime(this.driveDate);
    });
  }

  getRelativeTime(date) {
    const now = new Date();
    const diffMinutes = differenceInMinutes(date, now);
    const diffDays = differenceInDays(date, now);

    if (Math.abs(diffMinutes) < 60) {
      if (diffMinutes > 0) {
        return `in ${Math.abs(diffMinutes)} minutes`;
      } else {
        return `${Math.abs(diffMinutes)} minutes ago`;
      }
    } else if (Math.abs(diffDays) < 1) {
      const hours = Math.floor(Math.abs(diffMinutes) / 60);
      if (diffMinutes > 0) {
        return `in ${hours} hours`;
      } else {
        return `${hours} hours ago`;
      }
    } else {
      if (diffDays > 0) {
        return `in ${diffDays} days`;
      } else {
        return `${Math.abs(diffDays)} days ago`;
      }
    }
  }

  submitGrade(grade) {
    const data = {
      drive_id: this.$stateParams.driveId,
      student_id: this.$stateParams.studentId,
      grade: grade,
    };

    this.ReportcardsModel.submitPassFailGrade(data).then((response) => {
      this.FlashService.setMessage({
        type: "success",
        message: response.message,
      });
      this.$state.go("drivecoach.admin.reportcards");
    });
  }

  deleteReportCard(reportcard_id) {
    const confirm = this.$window.confirm(
      "Are you sure you want to delete this report card? THIS CANNOT BE UNDONE.",
    );
    if (confirm === false) {
      return;
    }
    this.busy = true;
    this.ReportcardsModel.destroy({ id: reportcard_id })
      .then((response) => {
        this.busy = false;
        this.$state.go("drivecoach.admin.reportcards");
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
      })
      .catch((Error) => {
        this.busy = false;
      });
  }
}
CreatePassFailReportCardController.$inject = [
  "$state",
  "$stateParams",
  "DrivesModel",
  "FlashService",
  "ReportcardsModel",
  "student",
  "$window",
];

export default CreatePassFailReportCardController;
